import(/* webpackMode: "eager" */ "/github/workspace/src/app/[locale]/page.tsx");
